import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getBaseQueryWithReauth from '../../../utils/api/query-auth';
import getAuth from '../../../utils/api/getToken';
import { handleData } from '../../slices/backoffice/backofficeCompanyDetailSlice';

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_BASE_URL}/Company`,
  prepareHeaders: (headers) => {
    const token = getAuth();
    if (token) {
      headers.set('authorization', `Bearer ${token.auth}`);
    }
    return headers;
  },
});

export const backofficeDetailApi: any = createApi({
  reducerPath: 'backofficeDetail',
  baseQuery: getBaseQueryWithReauth(baseQuery),
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getCompanyDescription: builder.query({
      query: (companyDatabaseId) => {
        return {
          url: '/getCompanyDescription',
          params: { companyDatabaseId },
        };
      },
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            handleData({
              data: data?.data,
              status: data.status,
              path: data?.path,
              message: data?.message,
            }),
          );
        } catch {
          console.error('Error in getting PageDetails data');
        }
      },
    }),
    putUpdateCompanyDescription: builder.mutation({
      query: (body) => ({
        url: `/updateCompanyDescription`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetCompanyDescriptionQuery,
  usePutUpdateCompanyDescriptionMutation,
} = backofficeDetailApi;
